import styled, { css } from 'styled-components';
import { Col } from 'reactstrap';
import { StyledLeadText } from '@whitelabel/component-library';
import {
  multiply,
  spacer,
  color,
  borderRadius,
  boxShadow,
  mediaBreakpointUp,
  mediaBreakpointDown,
  marginBottom,
  fontSize,
  zIndex,
} from '@whitelabel/helpers/style';
import loginHeroXs from '../../../media/images/login-hero-xs.jpg';
import loginHero from '../../../media/images/login-hero.jpg';
import Layout from '../../../components/Layout';
import { StyledMain, StyledHeader } from '../../../components/Layout/styled';
import { StyledHeadingBlock } from '../../../styled';

export const StyledLayout = styled(Layout)`
  ${StyledMain}, ${StyledHeader} {
    margin-bottom: 0;
  }
`;

export const StyledBGWrapper = styled.div<{ $rtl: boolean }>`
  ${({ $rtl }) => ($rtl ? `position: relative;` : ``)}
  min-height: ${multiply(spacer, 11.25)};
  overflow: hidden;
  ${({ $rtl }) =>
    $rtl
      ? css`
          &:before {
            position: absolute;
            width: 100%;
            height: 100%;
            background-image: url(${loginHeroXs});
            ${mediaBreakpointUp('sm')`
              background-image: url(${loginHero});
            `}
            background-position: 70% center;
            background-size: cover;
            content: '';
            transform: scaleX(-1);
            z-index: ${zIndex('behindContent')};
          }
        `
      : css`
          background-image: url(${loginHeroXs});
          ${mediaBreakpointUp('sm')`
              background-image: url(${loginHero});
            `}
          background-position: 70% center;
          background-size: cover;
        `}
`;

export const StyledSignUpHeadingBlock = styled(StyledHeadingBlock)`
  ${marginBottom}
  ${StyledLeadText} {
    ${mediaBreakpointUp('md')`
      font-size: ${multiply(fontSize('base'), 1.125)};
    `}
  }
`;

export const StyledSignUpBlock = styled(Col)`
  margin-top: ${multiply(spacer, -7.25)};
  margin-bottom: ${multiply(spacer, 2)};
  padding: ${spacer};
  background-color: ${color('white')};
  border-radius: ${borderRadius('base')};
  ${mediaBreakpointDown('sm')`
    box-shadow: ${boxShadow('md')};
  `}
  ${mediaBreakpointUp('sm')`
    box-shadow: ${boxShadow('md')};
    margin-top: ${multiply(spacer, 3)};
    margin-bottom: ${multiply(spacer, 3)};
    padding: ${multiply(spacer, 1.5)}
  `}
  ${mediaBreakpointUp('md')`
    padding: ${multiply(spacer, 2)}
  `}
    ${mediaBreakpointUp('lg')`
    margin-top: ${multiply(spacer, 6.5)};
    margin-tobottom${multiply(spacer, 6.5)};
    padding: ${multiply(spacer, 3)}
  `}
`;
